(function(angular){
    'use strict';

    angular.module('aprima-provider-api').factory('ImoDiagnosisService', [
        '_',
        '$q', 
        'AprimaCache',
        'ImoDiagnosisRepository',
        ImoDiagnosisService
    ]);

    function ImoDiagnosisService(
        _,
        $q,
        AprimaCache,
        ImoDiagnosisRepository
    ) {
        var service = {
            term: term,
            terms: terms,
            detail: detail,
            details: details
        };

        return service;

        function term(code, localCache) {
            var result = getSingle(code, AprimaCache.ImoTerms, localCache, ImoDiagnosisRepository.term);
            return result;
        }

        function terms(codes, localCache) {
            var result = getList(codes, AprimaCache.ImoTerms, localCache, ImoDiagnosisRepository.terms);
            return result;
        }

        function detail(code, localCache) {
            var result = getSingle(code, AprimaCache.ImoDetails, localCache, ImoDiagnosisRepository.detail);
            return result;
        }

        function details(codes, localCache) {
            var result = getList(codes, AprimaCache.ImoDetails, localCache, ImoDiagnosisRepository.details);
            return result;
        }


        function getSingle(code, aprimaCache, localCache, getData) {
            localCache = localCache || {};

            var result = localCache[code] || aprimaCache.get(code);
            if(result && result.LexicalCode === code) {
                return $q.when(result);
            }

            return getData(code).then(function(data) {
                if(!data || !data.LexicalCode) {
                    return $q.reject('Could not retrieve IMO term');
                }

                if(data.plain) {
                    data = data.plain();
                }
                localCache[code] = data;
                aprimaCache.put(code, data);
                return data;
            });
        }

        function getList(codes, aprimaCache, localCache, getData) {
            if(_.isArray(codes)) {
                if(_.isEmpty(codes)) {
                    return $q.when([]);
                }
            }
            else {
                codes = [codes];
            }

            localCache = localCache || {};
            var result = [];
            var codesToBeLoaded = [];
            _.forEach(codes, function(code) {
                var item = localCache[code] || aprimaCache.get(code);
                if(item && item.LexicalCode === code) {
                    result.push(item);
                }
                else {
                    codesToBeLoaded.push(code);
                }
            });

            if(_.isEmpty(codesToBeLoaded)) {
                return $q.when(result);
            }

            return getData({
                LexicalCodes: codesToBeLoaded,
            }).then(function(data) {
                if(!data || !data.Results) {
                    return $q.reject('Could not retrieve all IMO terms');
                }

                _.forEach(data.Results, function(term) {
                    localCache[term.LexicalCode] = term;
                    aprimaCache.put(term.LexicalCode, term);
                    result.push(term);
                });
                return result;
            });
        }
    }
})(window.angular);
